import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsUserConnected, selectUserPicture } from '../../store/userAccount/userAccount.selectors'
import s from './UserPicture.less'
import compteUser from './assets/compte-user.svg?raw'

const UserPicture = ({ wrapperClassName, defaultIconClassName, userPicClassName }) => {
  const connected = useSelector(selectIsUserConnected)
  const picture = useSelector(selectUserPicture)
  const shouldDisplayPicture = connected && picture

  return (
    <div className={classnames(s.root, wrapperClassName)}>
      <div className={classnames(s.circle, connected && s.connected)}>
        <span
          dangerouslySetInnerHTML={{ __html: compteUser }}
          className={classnames(s.defaultIcon, defaultIconClassName)}
        />
        {shouldDisplayPicture && (
          <div className={classnames(s.userPic, userPicClassName)} style={{ backgroundImage: `url('${picture}')` }} />
        )}
      </div>
    </div>
  )
}

export default UserPicture
